import { createFileRoute } from "@tanstack/react-router";
import { ChevronDown, Plus } from "@untitled-ui/icons-react";
import { useState } from "react";
import { useTranslation } from "react-i18next";

import Container from "@/components/containers/Container";
import Tab from "@/components/containers/tabs/Tab";
import TabGroup from "@/components/containers/tabs/TabGroup";
import TabList from "@/components/containers/tabs/TabList";
import TabPanel from "@/components/containers/tabs/TabPanel";
import TabPanels from "@/components/containers/tabs/TabPanels";
import Button from "@/components/forms/Button";
import TableSkeleton from "@/components/loadings/skeleton/TableSkeleton";
import type { ChildRouteContext } from "@/root";

import CreateMeetRoomModal from "../../../../components/sessions/CreateMeetRoomModal";
import MeetJoinByLink from "../../../../components/sessions/MeetJoinByLink";
import MeetRoomList from "../../../../components/sessions/MeetRoomList";
import { fetchMeetRoomsQueryOptions } from "../../../../services";

export const Route = createFileRoute("/_panel/_meet/meet/sessions/")({
  pendingComponent: TableSkeleton,
  beforeLoad: ({ context }) =>
    ({
      crumb: [{ label: context.t("Sessions", { ns: "meet.user" }) }],
    }) satisfies ChildRouteContext,
  loader: (opts) =>
    opts.context.queryClient.prefetchQuery(
      fetchMeetRoomsQueryOptions(0, { filters: { status: "ongoing" } }),
    ),
  component: Component,
});

function Component() {
  const { t } = useTranslation("meet.user");
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <>
      {isModalOpen && (
        <CreateMeetRoomModal
          open={isModalOpen}
          onClose={() => setIsModalOpen(false)}
        />
      )}
      <Container title={t("Sessions")}>
        <div className="flex flex-col gap-4">
          <MeetJoinByLink />

          <TabGroup>
            <div className="flex items-end gap-7">
              <TabList className="min-w-0 flex-1">
                <Tab>{t("Ongoing")}</Tab>
                {/* <Tab>{t("Upcoming")}</Tab> */}
                <Tab>{t("Ended")}</Tab>
              </TabList>
              <Button
                color="primary"
                size="lg"
                className="mb-5"
                startIcon={<Plus className="size-5" />}
                endIcon={<ChevronDown className="size-4" />}
                onClick={() => setIsModalOpen(true)}
              >
                {t("New session")}
              </Button>
            </div>
            <TabPanels>
              <TabPanel className="py-4">
                <MeetRoomList status="ongoing" />
              </TabPanel>
              <TabPanel className="py-4">
                <MeetRoomList status="upcoming" />
              </TabPanel>
              <TabPanel className="py-4">
                <MeetRoomList status="ended" />
              </TabPanel>
            </TabPanels>
          </TabGroup>
        </div>
      </Container>
    </>
  );
}
